const initialItems = [
    {
      id: "1",
      title: "Features",
      items: [{elem: "iPhone And iPad app",links: "/signup"}, {elem:"Android-app",links: ""}, {elem: "User Reviews", links: ""}, {elem: "MyNetDiary vs MyFitnessPal", links: ""}],
    },
    {
      id: "2",
      title: "Diets",
      items: [{elem: "Calorie Counting", links: ""},{elem: "Low-Carb", links: "Keto"},{elem: "High-Protein", links: ""},{elem: "Low-Fat", links: ""},{elem: "Mediterranean", links: ""}, {elem: "Vegetarian", links: ""}, {elem:"Vegan", links: ""}],
    },
    {
      id: "3",
      title: "Library",
      items: [{elem: "Weight Loss Blog", links: ""}, {elem: "Diet Library", links: ""}, {elem: "Dietitian team", links: ""}],
    },
    {
      id: "4",
      title: "Food",
      items: [{elem: "Food Search", links: ""}, {elem: "Database Licensing & Api", links: ""}],
    },
    {
      id: "5",
      title: "Business",
      items: [{elem: "Find Healthcare Professional", links: ""}, {elem: "For Healthcare Professional", links: ""}, {elem: "For Trainers and Clubs", links: ""}, {elem: "MyNetDiary vs MyFitnessPal", links: ""}, {elem: "Food Database Licensing", links: ""}],
    },
  ]


export default initialItems